import {Component, Input, OnChanges} from '@angular/core';
import {Observable} from 'rxjs';

interface DistributionBarVm {
  title: string;
  value: number;
  color: string;
}

@Component({
  selector: 'app-scaled-distribution-bars',
  templateUrl: './scaled-distribution-bars.component.html',
  styleUrls: ['./scaled-distribution-bars.component.scss']
})
export class ScaledDistributionBarsComponent implements OnChanges {
  @Input() responseDistributionObs: Observable<any> | undefined;

  rows: DistributionBarVm[] = [];

  private responseDistribution: any;

  ngOnChanges(): void {
    this.responseDistributionObs?.subscribe(res => {
      if (res) {
        this.responseDistribution = res;
        this.setRows();
      }
    });
  }

  trackByTitle(index: number, row: DistributionBarVm) {
    return row.title ?? index;
  }

  private setRows() {
    const responses = this.responseDistribution?.responses ?? {};
    this.rows = Object.keys(responses).map(title => ({
      title,
      value: responses[title],
      color: this.getBarColor(responses[title])
    }));
  }

  private getBarColor(value: number): string {
    if (value >= 60) {
      return '#6085FF';
    }
    if (value >= 40) {
      return '#819DFC';
    }
    if (value >= 20) {
      return '#A4B5EF';
    }
    return '#B7C1EA';
  }
}
